<template>
  <div class="login-block">
    <div class="login-title">
      <h5 @click="$emit('update', 'recoveryB')">密码重置</h5>
      <p>{{ errMessage }}</p>
    </div>
    <el-form
      ref="resetPass"
      class="login-form"
      :model="resetPass"
      :rules="rules"
      :show-message="false"
      size="medium"
    >
      <el-form-item prop="telNumber">
        <el-input
          :value="resetPass.telNumber"
          @input="handleInputMobile"
          maxlength="13"
          clearable
          placeholder="手机"
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verCode" class="pr">
        <el-input
          :value="resetPass.verCode"
          @input="handleInputCode"
          maxlength="7"
          placeholder="验证码"
          v-on:keyup.enter.native="submitForm"
          autocomplete="off"
        ></el-input>
        <v-code
          class="vcode"
          session-name="TIME_ACCOUNT_RECOVERY"
          action-path="/user-server/user/sendShortMessage"
          :action-data="actionData"
          @send="handleSend"
        ></v-code>
      </el-form-item>
    </el-form>

    <div class="link-box clearfix"></div>
    <div class="btn-box">
      <v-button @click="submitForm" :loading="loading">继&emsp;续</v-button>
    </div>
  </div>
</template>

<script>
import vCode from '@/components/vCode'

import aes from '@/uitls/aes'
import { settCookie, getUrlParams } from '@/uitls/index'
import vButton from './vButton.vue'

export default {
  components: {
    vCode,
    vButton
  },
  data() {
    // mobile validator
    const validateMobile = (rule, value, callback) => {
      let reg = /^1/
      if (!reg.test(value)) {
        callback(new Error('手机格式有误'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      errMessage: '',
      // 表单
      resetPass: {
        mobile: '',
        code: '',
        telNumber: '',
        verCode: ''
      },
      rules: {
        telNumber: [{ validator: validateMobile, trigger: 'change' }],
        verCode: [
          { required: true, message: '请输入验证码', trigger: 'change' },
          { min: 7, max: 7, message: '长度为6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionData: function() {
      return {
        phoneNo: this.resetPass.mobile,
        motion: 'resetMm'
      }
    }
  },
  methods: {
    handleInputMobile(val) {
      const s = val.replace(/[^\d]/g, '')
      this.resetPass.mobile = s
      this.resetPass.telNumber = s.replace(
        /(\d{1,3})(\d{1,4})?(\d{1,4})?/g,
        (str, a, b, c) => {
          if (c) {
            return `${a} ${b} ${c}`
          } else if (b) {
            return `${a} ${b}`
          } else if (a) {
            return `${a}`
          }
        }
      )
    },
    handleInputCode(val) {
      const s = val.replace(/[^\d]/g, '')
      this.resetPass.code = s
      this.resetPass.verCode = s.replace(
        /(\d{1,3})(\d{1,3})?/g,
        (str, a, b) => {
          if (b) {
            return `${a} ${b}`
          } else if (a) {
            return `${a}`
          }
        }
      )
    },
    doLoading() {
      this.loading = true
    },
    doCloseLoading() {
      this.loading = false
    },
    // vcode callback
    handleSend(t) {},

    // 提交表单
    submitForm() {
      this.$refs.resetPass.validate(valid => {
        if (valid) {
          this.doLoading()
          this.$http
            .post('/user-server/user/checkVCode', {
              phoneNo: this.resetPass.mobile,
              motion: 'resetMm',
              vCode: this.resetPass.code
            })
            .then(res => {
              this.doCloseLoading()
              if (res.data.code == 200) {
                let json = {}
                json.telNumber = this.resetPass.mobile
                json.verCode = this.resetPass.code
                sessionStorage.setItem('resetInfo', JSON.stringify(json))

                this.$emit('update', 'recoveryB')
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              this.doCloseLoading()
              console.log('ERROR', err)
            })
        } else {
          return false
        }
      })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import './../styles/login.scss';
</style>
<style lang="scss">
@import '../styles/form.scss';
</style>



// WEBPACK FOOTER //
// src/views/index/components/recoveryA.vue